import { Feedback } from '@/components/feedback';
import { ENV } from '@/app/config';
import { MY_ADS_PAGE, MY_ADS_TEST_IDS } from '../../utils';
import { CarIcon } from './icons';

const EmptyState = () => (
	<Feedback
		dataTestId={MY_ADS_TEST_IDS.EMPTY_STATE}
		actionTestId={MY_ADS_TEST_IDS.EMPTY_STATE_CREATE_BUTTON}
		icon={<CarIcon />}
		title={MY_ADS_PAGE.EMPTY_STATE.TITLE}
		description={MY_ADS_PAGE.EMPTY_STATE.DESCRIPTION}
		action={{
			label: MY_ADS_PAGE.CREATE_AD_BUTTON,
			onClick: () => {
				window.open(ENV.URL_SELL, '_blank', 'noopener,noreferrer');
			},
			variant: 'situational'
		}}
	/>
);

EmptyState.displayName = 'EmptyState';

export { EmptyState };
